"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.onboardingQuery1 = "{\n  allPosts {\n    imageUrl\n    # description\n  }\n}";
exports.onboardingQuery1Check = "{allPosts{imageUrldescription}}";
exports.onboardingEmptyMutation = "mutation {\n  createPost(\n    imageUrl: \"\"\n    description: \"\"\n  ) {\n    id\n  }\n}";
exports.onboardingFilledMutation1 = "mutation {\n  createPost(\n    imageUrl: \"http://bit.ly/2pLtEdd\"\n    description: \"Cat\"\n  ) {\n    id\n  }\n}";
exports.onboardingFilledMutation2 = "mutation {\n  createPost(\n    imageUrl: \"http://bit.ly/2pLDBrf\"\n    description: \"Another Cat\"\n  ) {\n    id\n  }\n}";


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/data.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/data.js
// module chunks = 0